export default __webpack_public_path__ + "static/media/LightleftSideHeader.1a3a7ecc.png";